import type { PropertyValue } from "@ext/properties/models";
import { Display } from "@ext/properties/models/display";

/** What the filter/sort/group/select/display controls of a view produce, wherever the view is rendered. */
export interface ViewSettings {
	defs: PropertyValue[];
	orderby: PropertyValue[];
	groupby: string[];
	select: string[];
	display: Display;
}

export const DEFAULT_VIEW_SETTINGS: ViewSettings = {
	defs: [],
	orderby: [],
	groupby: [],
	select: [],
	display: Display.List,
};

/** A board lays out one property across its columns, so switching to it drops every extra grouping. */
export const getDisplayPatch = (settings: ViewSettings, display: Display): Partial<ViewSettings> => {
	if (display === Display.Kanban && settings.groupby.length > 1) return { display, groupby: [settings.groupby[0]] };
	return { display };
};
